import { SupportTicket } from '../../../types/commonTypes';
import moment from 'moment';
import { Label } from '../../../components/Label';
import { CollapsableContent } from '../../../components/CollapsableContent/CollapsableContent';
import clsx from 'clsx';

interface Props {
  isMobile: boolean;
  ticketData: SupportTicket;
}

export const ViewTicketDetails = (props: Props) => {
  if (props.isMobile)
    return (
      <CollapsableContent
        className="border-b border-border-light dark:border-border-dark"
        header="View Ticket Details"
      >
        <TicketDetails {...props} />
      </CollapsableContent>
    );
  return <TicketDetails {...props} />;
};

const TicketDetails = ({ isMobile, ticketData }: Props) => {
  const ticketAge = moment(Date.now()).diff(ticketData.createdAt, 'days');
  return (
    <div
      className={clsx('inline-flex flex-wrap items-center w-full', {
        'p-4 border-b border-border-light dark:border-border-dark gap-4 justify-between':
          !isMobile,
        'gap-2 justify-start': isMobile,
      })}
    >
      <Label text="Ticket">{ticketData.displayID}</Label>
      <Label text="Priority">{ticketData.priority}</Label>
      <Label text="Type">{ticketData.categoryName}</Label>
      <Label text="Status">{ticketData.behavior}</Label>
      <Label text="Opened By">{ticketData.user}</Label>
      <Label text="Days Since Created">
        {Number.isFinite(ticketAge) ? `${ticketAge} Day(s)` : 'N/A'}
      </Label>
    </div>
  );
};
